import store from '../store/Store';
import actionTypes from '../actionTypes/actionTypes';

async function changeTemplate(data) {
	console.log(data);

	store.dispatch(data)
}

async function startedTemplate(data) {
	console.log(data)

	store.dispatch(data)
}

const templateActions = {
	changeTemplate,
	startedTemplate
}

export default templateActions;